angular
  .module("tcMailgun")
  .directive("tcMailgun", tcMailgun)
  .directive("tcMailgunAlternative", tcMailgunAlternative)
  .directive("tcMailgunContainer", tcMailgunContainer);

function tcMailgunContainer() {
  return {
    transclude: true,
    template: "<ng-transclude></ng-transclude>",
    controller: function () {
      var didYouMean;

      this.setAlternative = function (x) {
        didYouMean = x;
      };

      this.getAlternative = function () {
        return didYouMean;
      };
    },
  };
}

function tcMailgun($q, tcMailgunPersistance) {
  return {
    require: ["ngModel", "?^tcMailgunContainer"],
    link: function (scope, elem, attrs, ctrls) {
      var ngModelCtrl = ctrls[0];
      var setAlternative = ctrls[1] ? ctrls[1].setAlternative : R.identity;

      ngModelCtrl.$asyncValidators.mailgun = function (modelValue, viewValue) {
        var value = modelValue || viewValue;
        if (!value) {
          return $q.resolve(true);
        }
        return tcMailgunPersistance.validate(value).then(
          function (res) {

            scope.$parent[attrs.tcMailgun] = res.did_you_mean;
            setAlternative(res.did_you_mean);

            if (res.is_valid) {
              return $q.resolve(true);
            } else {
              return $q.reject("invalid");
            }
          },
          function (res) {
            if (res.status == -1) {
              return $q.resolve(true);
            }
          }
        );
      };
    },
  };
}

function tcMailgunAlternative() {
  return {
    scope: {
      onChange: "&",
    },
    require: "?^tcMailgunContainer",
    template:
      "<a ng-click='onChange({ $alt: alt })' ng-bind='alt' href='javascript:void(0)'><a>",
    link: function (scope, elem, attrs, tcMailgunContainerCtrl) {
      scope.alt = tcMailgunContainerCtrl.getAlternative();
    },
  };
}
